import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RequestParams, ResponseCatalog, FormErrorModel } from 'Models'
import { Callback } from 'Src/types/utilTypes'
import { OptionModel } from 'Pages/survey'

type OptionState = {
	saveChain: OptionModel[]
	needSave?: boolean
	params: RequestParams
}

const initialState: OptionState = {
	saveChain: [],
	needSave: undefined,
	params: new RequestParams(),
}

export namespace OptionNS {
	export type SetParams = PayloadAction<RequestParams>
	export type GetOne = PayloadAction<number>
	export type SetOne = PayloadAction<ResponseCatalog<OptionModel>>
	export type CreateOne = PayloadAction<{
		survey_id: number
		question_id: number
		data: OptionModel
		callback?: Callback
		errorCallback?: Callback
	}>
	export type CreateOnes = PayloadAction<{
		survey_id: number
		question_id: number
		datalist: OptionModel[]
		callback?: Callback
	}>
	export type UpdateOne = PayloadAction<{
		survey_id: number
		data: OptionModel
		callback?: Callback
		errorCallback?: Callback
	}>
	export type DeleteOne = PayloadAction<{ id: number; callback?: Callback }>
	export type SetOptionFromError = PayloadAction<{ data: FormErrorModel }>

	export type SetSaveChain = PayloadAction<OptionModel[]>
	export type NeedSave = PayloadAction<boolean>
}

export const optionSlice = createSlice({
	name: 'option',
	initialState,
	reducers: {
		setParams: (state, action: OptionNS.SetParams) => {
			state.params = action.payload
		},
		getOne: (state, action: OptionNS.GetOne) => {},
		setOne: (state, action: OptionNS.SetOne) => {},
		createOne: (state, action: OptionNS.CreateOne) => {},
		createOnes: (state, action: OptionNS.CreateOnes) => {},
		updateOne: (state, action: OptionNS.UpdateOne) => {},
		deleteOne: (state, action: OptionNS.DeleteOne) => {},
		setOptionFromError: (state, action: OptionNS.SetOptionFromError) => {},
		setSaveChain: (state, action: OptionNS.SetSaveChain) => {
			state.saveChain = action.payload
		},
		needSave: (state, action: OptionNS.NeedSave) => {
			state.needSave = action.payload
		},
	},
})
